export const SET_ACCOUNT = 'SET_ACCOUNT'

export const CLEAR_ACCOUNT='CLEAR_ACCOUNT'





// WEBPACK FOOTER //
// ./src/store/user/mutation-types.js